import {LiteralUnionAutocomplete, Nullish} from 'shared/web';

export type InvoicePaymentFormValues = {
  amount: string;
  paymentDate: string;
  paymentType: LiteralUnionAutocomplete<'CASH' | 'PAYMENT_CARD' | 'BANK_TRANSFER' | 'OFFSET'>;
  cashRegister: string;
  shouldCreateReceipt: boolean | Nullish;
  exchangeRateRatio: {
    amount: string | null;
    ratio: string | null;
  };
};
